<template>
  <nut-row class="errorPage">
    <svg-icon icon-class="anonymous" class-name="big"/>
    <span>已退出登录</span>
    <router-link to="/" style="margin-top: 5%">
      <nut-button>重新登录</nut-button>
    </router-link>
  </nut-row>
</template>

<script>
import SvgIcon from "@/components/SvgIcon";
export default {
  name: "LogoutView",
  components: {SvgIcon}
}
</script>

<style lang="scss" scoped>
.errorPage{
  display: flex;
  flex-direction: column;
  font-size: 25px;
  color: #498ce3;
  justify-items: center;
  align-items: center;
  margin-top: 30%;
}
</style>